<template>
    <v-container fluid>

        <!-- Loading Dialog -->
        <v-dialog v-model="loading" max-width="200" persistent>
            <v-card elevation="12" class="text-center" color="white">
                <v-card-text>
                <v-progress-circular indeterminate color="primary" size="20" class="pt-10" ></v-progress-circular>
                <div class="loading-text">Carregando...</div>
                </v-card-text>
            </v-card>
        </v-dialog>


      <v-row v-if="loadResults.length > 0">
        <v-col cols="12">
          
          <v-card>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12" md="6" lg="6">
                  <v-card class="metric-card" style="padding: 0px;">
                    <v-card-text>
                        <v-card-title style="padding-top: 0px;" class="card-title-bold">
                            <span class="card-title-text"> Total Acumulado</span>
                        </v-card-title>
                      <div class="d-flex align-center">
                        <v-progress-circular 
                          :size="150"
                          :width="15"
                          :value=loadResults[0].totalRightPercent
                          color="primary"
                          filled
                        >
                        <h2>{{loadResults[0].totalRightPercent}}%</h2>
                        </v-progress-circular>
                        <div class="text-xs-center ml-12">
                          <h4>Total de Questões Respondidas:</h4>
                          <p>{{ loadResults[0].totalQuestions }}</p>
                          <h4>Total de Acertos ({{loadResults[0].totalRightPercent}}%):</h4>
                          <p>{{ loadResults[0].totalRight }}</p>
                          <h4>Total de Erros ({{loadResults[0].totalWrongPercent}}%):</h4>
                          <p>{{ loadResults[0].totalWrong  }}</p>
                        </div>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                        <small>Nota: O Total Acumulado apresenta métricas referentes a soma de todas as questões realizadas.</small>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6" lg="6">
                  <v-card class="metric-card" style="padding: 0px;">
                    <v-card-text>
                        <v-card-title style="padding-top: 0px;" class="card-title-bold">
                            <span class="card-title-text"> Último conjunto de Questões</span>
                        </v-card-title>
                      <div class="d-flex align-center">
                        <v-progress-circular
                          :size="150"
                          :width="15"
                          :value=loadResults[0].lastRightPercent
                          color="success"
                          filled
                        >
                        <h2>{{loadResults[0].lastRightPercent}}%</h2>
                        </v-progress-circular>
                        <div class="text-xs-center ml-12">
                          <h4>Questões respondidas no conjunto de Questões</h4>
                          <p>{{ loadResults[0].lastQuestions }}</p>
                          <h4>Acertos no último conjunto de Questões ({{ loadResults[0].lastRightPercent }}%):</h4>
                          <p>{{ loadResults[0].lastRight }}</p>
                          <h4>Erros no último conjunto de Questões ({{ loadResults[0].lastWrongPercent }}%):</h4>
                          <p>{{ loadResults[0].lastWrong }}</p>
                         </div>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                        <small>Nota: conjunto de Questões realizado em: {{loadResults[0].lastTest }}.</small>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="12" md="12" lg="12">
                  <v-card class="metric-card" style="padding: 0px;">
                    <v-card-text>
                        <v-card-title style="padding-top: 0px;" class="card-title-bold">
                          <v-btn class ="mr-2 mb-3"icon @click="refreshData">
                                <v-icon>mdi-refresh</v-icon>
                          </v-btn>
                        <span class="card-title-text"> Métricas por Tema</span>
                              
                        </v-card-title>
                       <!-- Seção para exibir as estatísticas por tema -->
                       <v-container>
                            <div v-if="loadResults[0].additionalData.every(item => item.value === '' || item.value === null)">
                              <v-alert :value="true" color="info" outlined>
                                Nenhuma estatística disponível. Complete novos conjunto de Questões para apresentar métricas individuais por tema.
                              </v-alert>
                            </div>
                            <v-data-table
                              v-else
                              :headers="tableHeaders"
                              :items="loadResults[0].additionalData"
                              class="elevation-1"
                              :mobile-breakpoint="0"
                              :disable-sort="true"
                              :loading="additionalLoading"
                            >
                              <template v-slot:item="{ item }">
                                <tr v-if="item.value !== '' && item.value !== null" class="table-row">
                                  <td>{{ item.theme || 'Carregando...' }}</td>
                                  <td>{{ item.themeRight !== undefined ? item.themeRight : '...' }}</td>
                                  <td>{{ item.value !== undefined ? item.value : '...' }}</td>
                                  <td>
                                    <span v-if="item.themeRight !== undefined && item.value !== undefined" 
                                          :class="getPercentageClass(item.themeRight / item.value * 100)">
                                      {{ (item.themeRight / item.value * 100).toFixed(2) }}%
                                    </span>
                                    <span v-else>...</span>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                            <div class="legend mt-3" >
                              <div class="legend-item">
                                <span class="legend-color excellent"></span>
                                <span class="ml-1 mr-2">Excelente</span>
                                <span class="legend-color good"></span>
                                <span class="ml-1 mr-2">Bom</span>
                                <span class="legend-color average"></span>
                                <span class="ml-1 mr-2">Médio</span>
                                <span class="legend-color to-improve"></span>
                                <span class="ml-1 mr-2">A Melhorar</span>
                              </div>
                            </div>
                          </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <small>Nota: Apenas conjunto de Questões após 31.01.2023 apresentam métricas individuais por tema.</small>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <!-- Add more metric cards -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else justify="center">
        <v-col cols="12" sm="8" md="6">
            <v-card class="text-center" elevation="5">
            <v-card-text>
                <v-icon x-large color="grey lighten-1">mdi-folder-question</v-icon>
                <p class="mt-3 font-weight-bold">Nenhum dado disponível. </p>
                <p class="mt-3 text-left">1. Acesse a Aba "Treinar Questões" para iniciar seu primeiro conjunto de Questões.</p>
                <p class="mt-3 text-left">2. Complete seu primeiro conjunto de Questões para possuir dados disponíveis no Dashboard.</p>
            </v-card-text>
            </v-card>
        </v-col>
        </v-row>
    </v-container>
  </template>
  
  <script>
import { ref, computed, onMounted } from 'vue';
import { supabase } from '@/plugins/supabase';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();
    const loading = ref(true); // Carregamento dos dados principais
    const additionalLoading = ref(false); // Carregamento dos dados adicionais
    const results = ref([]);
    const tableHeaders = [
      { title: 'Tema' },
      { title: 'Acertos' },
      { title: 'Total de Questões Realizadas' },
      { title: 'Taxa de Acertos (%)' },
    ];

    // Busca o email do usuário logado (ajuste conforme sua autenticação)
    const userEmail = computed(() => store.state.user?.email);

    const fetchResults = async () => {
      loading.value = true;
      console.log('[Supabase] Buscando dados da tabela TEMFC_Results para o email:', userEmail.value);

      // Busca apenas os dados onde o email corresponde ao email do usuário
      const { data, error } = await supabase
        .from('temfc_results')
        .select('*')
        .eq('email', userEmail.value); // Filtra pelo email

      if (error) {
        console.error('[Supabase] Erro ao buscar resultados:', error);
        results.value = [];
      } else if (data && data.length) {
        console.log('[Supabase] Dados recebidos:', data);

        const row = data[0]; // Como só uma linha será retornada, acessamos diretamente o primeiro item
        const record = {
          email: row.email,
          totalQuestions: row.totalQuestions,
          totalRight: row.totalRight,
          totalWrong: row.totalWrong,
          lastQuestions: row.lastQuestions,
          lastRight: row.lastRight,
          lastWrong: row.lastWrong,
          lastTest: row.lastTest,
          totalRightPercent: ((row.totalRight / row.totalQuestions) * 100).toFixed(2),
          totalWrongPercent: ((row.totalWrong / row.totalQuestions) * 100).toFixed(2),
          lastRightPercent: ((row.lastRight / row.lastQuestions) * 100).toFixed(2),
          lastWrongPercent: ((row.lastWrong / row.lastQuestions) * 100).toFixed(2),
          name: row.name,
          questionIdHistory: row.questionIdHistory,
          questionIdBlackList: row.questionIdBlackList,
          numberofsim: row.numberofsim,
          additionalData: [], // Inicialmente vazio
        };

        // Atualiza os resultados principais para exibição imediata
        results.value = [record];
        console.log('[Supabase] Dados normalizados para o dashboard:', results.value);

        // Finaliza o carregamento dos dados principais
        loading.value = false;

        // Carrega os dados adicionais de forma assíncrona
        additionalLoading.value = true;
        await fetchAdditionalData(row, record);
        additionalLoading.value = false;
      } else {
        console.log('[Supabase] Nenhum dado encontrado para este email.');
        results.value = [];
        loading.value = false; // Finaliza o carregamento mesmo se não houver dados
      }
    };

    // Função para carregar os dados adicionais
    const fetchAdditionalData = async (row, record) => {
      const usedKeys = Object.keys(record); // Todas as chaves já usadas
      const correctKeys = {}; // Armazena as chaves com sufixo "_Corretas"

      for (const key in row) {
        if (!usedKeys.includes(key)) {
          if (key.endsWith('_Corretas')) {
            // Armazena as chaves "_Corretas" para processamento posterior
            const baseKey = key.split('_Corretas')[0];
            correctKeys[baseKey] = row[key];
          } else if (!isNaN(key)) {
            // Adiciona ao additionalData apenas se a key for um número
            record.additionalData.push({
              key: key,
              value: row[key],
              theme: null, // Inicialmente vazio, será preenchido depois
            });
          }
        }
      }

      // Atualiza o theme para cada item em additionalData onde key é um número
      for (const item of record.additionalData) {
        if (!isNaN(item.key)) {
          const { data: themeData, error: themeError } = await supabase
            .from('questions_themes_id')
            .select('theme')
            .eq('id', item.key)
            .single(); // Busca o nome do tema correspondente

          if (themeError) {
            console.error(`[Supabase] Erro ao buscar tema para key ${item.key}:`, themeError);
          } else {
            item.theme = themeData?.theme || `Tema não encontrado (ID: ${item.key})`;
          }
        }
      }

      // Associa os valores de "_Corretas" ao item correspondente em additionalData
      for (const baseKey in correctKeys) {
        const item = record.additionalData.find((data) => data.key === baseKey);
        if (item) {
          item.themeRight = correctKeys[baseKey]; // Adiciona a propriedade themeRight
        }
      }

      // Remove itens de additionalData que não possuem um tema válido, não são relevantes ou têm value vazio
      record.additionalData = record.additionalData.filter(
        (item) => item.key && !isNaN(item.key) && item.theme && item.value && item.value.trim() !== ''
      );

      // Atualiza os resultados com os dados adicionais
      results.value = [record];
      console.log('[Supabase] Dados adicionais carregados:', results.value[0].additionalData);
    };

    onMounted(fetchResults);

    // Função para atualizar os dados
    const refreshData = () => fetchResults();

    // Função para classificar porcentagem
    const getPercentageClass = (percentage) => {
      if (percentage >= 85) return 'excellent';
      if (percentage >= 70) return 'good';
      if (percentage >= 50) return 'average';
      return 'to-improve';
    };

    return {
      loading,
      additionalLoading,
      loadResults: results,
      tableHeaders,
      getPercentageClass,
      refreshData,
    };
  }
};
</script>
  
  <style>
  .metric-card {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 10px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }

  .card-title-bold {
  font-weight: bold;
  }

  .loading-text {
  margin-top: 15px;
  font-weight: bold;
  font-size: 18px;
  }
  .table-row:nth-child(even) {
  background-color: #ffffff;
}

.table-row:hover {
  background-color: #ddd;
}

.v-data-table__wrapper table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.excellent {
  background-color: rgba(0, 128, 0, 0.700);
  color: white;
  padding: 1px 10px;
  border-radius: 5px;
}

.good {
  background-color: rgba(0, 0, 255, 0.700);
  color: white;
  padding: 1px 10px;
  border-radius: 5px;
}

.average {
  background-color: rgba(255, 255, 0, 0.700);
  color: black;
  padding: 1px 10px;
  border-radius: 5px;
}

.to-improve {
  background-color: rgba(255, 0, 0, 0.700);
  color: white;
  padding: 1px 10px;
  border-radius: 5px;
}
  
  /* Add your custom styles here */
  </style>
